import { Label } from "reactstrap";
import TableComponent from "../../../components/TableComponent";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { checkNullValue } from "../../../utils/Util";
import { CUSTOMER_DETAILS_HEADERS } from "../DashboardHelper";

const CustomerDetails = (props: any) => {
    const {
        selectedApplication,
        storeCustomerDetailsSearchData
    } = useSelector((state: any) => state.grievances);
    const [tableData, setTableData] = useState<any>([]);

    const navigateToPrev = () => {
        if(props?.getValues('searchApplication') || props?.getValues('searchPMFBYPolicy') || props?.getValues('searchRWBCISPolicy') || props?.getValues('searchRWBCISApplication')){
            props?.setShowApplicationTable(true)
            props?.setShowCustomerTable(false)
        }
        else if(props?.getValues('searchMobile')){
            props?.setRetailApplicationTable(true)
            props?.setShowCustomerTable(false)
        }
        else if(props?.getValues('searchHealthMobile')){
            props?.setShowHealthDetails(true)
            props?.setShowCustomerTable(false)
        }
        else if(props?.getValues('searchPolicy') || props?.getValues('searchHealthPolicy')){
            props?.setSearchSection(true)
            props?.setShowCustomerTable(false)
        }
    }


    useEffect(() => {
        if(props?.getValues('searchPolicy') || props?.getValues('searchHealthPolicy')){
            setTableData(storeCustomerDetailsSearchData?.data);
        }
        else{
            setTableData([selectedApplication])
        }
    },[storeCustomerDetailsSearchData, selectedApplication])

    return (
        <>
            <Label>
                <img 
                    src={require('../../../assets/img/Back.svg').default} 
                    style={{marginRight:'15px', cursor: 'pointer'}}
                    onClick={navigateToPrev}
                />
                {checkNullValue(selectedApplication?.applicationId) != 'N/A' && (props?.getValues('searchApplication') || props?.getValues('searchPMFBYPolicy') || props?.getValues('searchRWBCISPolicy') || props?.getValues('searchRWBCISApplication')) && 
                    <span>Application Number: {selectedApplication?.applicationId}</span>
                }
                {checkNullValue(selectedApplication?.policyNo) != 'N/A' && (props?.getValues('searchMobile')  || props?.getValues('searchHealthMobile'))&& 
                    <span>Policy Number: {selectedApplication?.policyNo}</span>
                }
                {(checkNullValue(selectedApplication?.applicationId) == 'N/A' && selectedApplication?.fid?.length > 0) && (props?.getValues('searchMobile'))&& 
                    <span>FIN Number: {selectedApplication?.fid}</span>
                }
                {(checkNullValue(selectedApplication?.policyNo) == 'N/A' && selectedApplication?.cid?.length > 0) && (props?.getValues('searchHealthMobile'))&& 
                    <span>CID Number: {selectedApplication?.cid}</span>
                }
                {(props?.getValues('searchPolicy')) &&
                    <span>Policy Number: {props?.getValues('searchPolicy')}</span>
                }
                {(props?.getValues('searchHealthPolicy'))&&
                    <span>Policy Number: {props?.getValues('searchHealthPolicy')}</span>
                }
            </Label>
            <TableComponent 
                data={tableData}
                columnHeaders={CUSTOMER_DETAILS_HEADERS}
                onAction={props?.onTableAction}
                responsive={false}
            />
        </>
    );
}

export default CustomerDetails;